export const horizontalLayoutConfig = {
  medium: {
    gridSetup: {
      image: {
        columns: 6,
      },
      content: {
        columns: 8,
      },
      offset: {
        columns: 2,
      },
    },
  },
  large: {
    gridSetup: {
      image: {
        columns: 6,
      },
      content: {
        columns: 8,
      },
      offset: {
        columns: 2,
      },
    },
  },
};
